// Path: ./src/app/pages/UploadMenu/useMenuTableColumns.tsx
// setTableColumn.tsx

import { GridRenderCellParams } from "@mui/x-data-grid";
import { messages } from "../../../locales/messages";
import { AllowedTableColumn } from "../../../utils/types/AllowTableTypes";
import { RenderEditButton } from "../../components/RenderEditButtonTable";
import { useTranslation } from "react-i18next";
import { GfMenu, GfMenuDto } from "@swagger/typescript-fetch-goflyer";
import { makeStoreDisplayName } from "../../../utils/dtoUtil/makeStoreDisplayName";

export const useMenuTableColumns = (
  handleOnClickEdit: (value: GfMenuDto) => Promise<void>,
) => {
  const { t } = useTranslation();
  const values: AllowedTableColumn[] = ["updatedAt", "createdAt"];

  const columns = [
    {
      field: "edit",
      filterable: false,
      width: 90,
      headerName: `${t(messages.Edit())}`,
      renderCell: (props: GridRenderCellParams) => {
        return (
          <RenderEditButton
            onClick={handleOnClickEdit}
            {...props}
          ></RenderEditButton>
        );
      },
      sortable: false,
    },
    {
      field: "name",
      headerName: `${t(messages["name"]())}`,
    },
    {
      field: "merchant",
      width: 200,
      headerName: `${t(messages["Merchant"]())}`,
      sortable: false,
      renderCell: (params: GridRenderCellParams<GfMenu>) => {
        const store = params.row.stores[0];
        return <div>{store ? makeStoreDisplayName(store) : ""}</div>;
      },
    },
    {
      field: "menuTag",
      width: 200,
      headerName: `${t(messages["menuTag"]())}`,
      sortable: false,
      renderCell: (params: GridRenderCellParams<GfMenu>) => {
        const flyerTag = params.row.menuTag;
        return <div>{flyerTag?.map((tag) => tag.name).join(", ")}</div>;
      },
    },
    {
      field: "rank",
      headerName: `${t(messages["rank"]())}`,
      type: "number",
    },
    ...values.map((value) => {
      return {
        width: 200,
        field: value,
        headerName: `${t(messages[value]())}`,
        type: "dateTime",
        valueGetter: (val: GridRenderCellParams) => {
          return val && new Date(val?.row[value]);
        },
      };
    }),
    {
      field: "CreatedBy",
      filterable: false,
      width: 200,
      headerName: `${t(messages["CreatedBy"]())}`,
      sortable: false,
      renderCell: (params: GridRenderCellParams<GfMenu>) => {
        const { firstName, lastName, userName, email } =
          params?.row?.adminUser || {};
        const createdBy = firstName
          ? `${firstName} ${lastName || ""}`
          : userName || email || "";

        return <div title={createdBy.trim()}>{createdBy}</div>;
      },
    },
    {
      field: "id",
      filterable: false,
      width: 300,
      headerName: `${t(messages["id"]())}`,
    },
  ];

  return columns;
};
